module.exports = __webpack_public_path__ + "static/media/ae.12f7fbea.svg";